import ProductGet from './Get'
import ProductCreate from './Create'
import ProductUpdate from './Update'
import ProductDetails from './Details'
import ProductTags from './Tags'
import ProductDiscounts from './Discount'

export {
    ProductGet,
    ProductCreate,
    ProductUpdate,
    ProductDetails,
    ProductTags,
    ProductDiscounts,
}